export default __webpack_public_path__ + "static/media/ic_avalanche_testnet_24.b911b6d2.svg";